import axios from './axios'

export function getPressureConfigure() {
  return axios({
    method: "get",
    url: '/api/v1/threshold/'
  })
}

export function updatePressureConfigure(id,sub) {
  return axios({
    method: "put",
    url: '/api/v1/threshold/' + id + '/',
    data: sub
  })
}
